import { render, staticRenderFns } from "./contract-stats.vue?vue&type=template&id=132a416a"
import script from "./contract-stats.vue?vue&type=script&lang=js"
export * from "./contract-stats.vue?vue&type=script&lang=js"
import style0 from "./contract-stats.vue?vue&type=style&index=0&id=132a416a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports